import { apiBusSchedBaseURL } from '../../authentication/Global';
import { apiSchematicMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class UploadFileAPI {
    constructor(appName) {
        switch (appName) {
            case "bussched":
                this.fontBaseUrl = new URL("bussched/fonts/", apiBusSchedBaseURL);
                this.layoutBaseUrl = new URL("bussched/layouts/", apiBusSchedBaseURL);
                break;
            case "schematicmap":
                this.fontBaseUrl = new URL("schematicmap/fonts/", apiSchematicMapBaseURL);
                this.layoutBaseUrl = new URL("schematicmap/layouts/", apiSchematicMapBaseURL);
                break;
            default:
                this.fontBaseUrl = new URL("");
                this.layoutBaseUrl = new URL("");
                break;
        }
    }

    uploadFont(font) {
        return API.authenticatedRequest({
            url: this.fontBaseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: font
        });
    }

    uploadLayout(layout) {
        return API.authenticatedRequest({
            url: new URL("import", this.layoutBaseUrl),
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: layout
        });
    }
}